import React from 'react';

import { MiniIklan,AdsAddBox } from '.';


const ListMiniIklan=React.memo(props=>{
  const{
    listAds,
    light,
    onClickAds,
    onClickNew,
  }=props

  return (
    <>
      {listAds.map((ads,i)=>!!ads?<MiniIklan key={i} onClick={onClickAds} liveAds={ads} light={light}/>:<AdsAddBox key={i} onClick={onClickNew} light={light}/>)}
    </>
  )
})

export default ListMiniIklan